exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".opt-out-modal .modal-dialog{width:350px}.opt-out-modal .modal-dialog .modal-content .container p{text-align:left}@media (max-width:768px){.opt-out-modal .modal-dialog{top:30%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/view/reports/optOutModal.scss
// module id = 935
// module chunks = 0